/* eslint-disable */
const languages = [
  "da",
  "de",
  "en-au",
  "en-ca",
  "en-in",
  "en-us",
  "en",
  "es-mx",
  "es",
  "fi",
  "fr-ca",
  "fr",
  "hi",
  "it",
  "ja",
  "ko",
  "nb",
  "nl",
  "pl",
  "pt-pt",
  "pt",
  "ru",
  "sv",
  "zh-Hant",
  "zh"
] as const;
export default languages;
export type SupportedLanguage = typeof languages[number];
